import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

const Ctx = createContext({ content: null, status: "loading" });

export const ContentProvider = ({ children }) => {
  const [state, setState] = useState({ content: null, status: "loading" });

  useEffect(() => {
    if (!API) {
      setState({ content: null, status: "error" });
      return undefined;
    }
    let alive = true;
    axios
      .get(`${API}/content`)
      .then((r) => {
        if (alive) setState({ content: r.data ?? null, status: "ready" });
      })
      .catch(() => {
        if (alive) setState({ content: null, status: "error" });
      });
    return () => {
      alive = false;
    };
  }, []);

  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
};

export const useContent = () => useContext(Ctx);

export const usePizzas = () => {
  const { content } = useContent();
  return Array.isArray(content?.pizzas) ? content.pizzas : [];
};

export const usePates = () => {
  const { content } = useContent();
  return Array.isArray(content?.pates) ? content.pates : [];
};

export const useHours = () => {
  const { content } = useContent();
  return Array.isArray(content?.hours) ? content.hours : [];
};
